import JobFeedsListWidget from '@jobseeker/feature-job/widgets/JobfeedV2';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {shallowEqual, useSelector} from 'react-redux';

import type {AppState} from '@jobseeker/common-core/types';
import type {AdElement} from '@jobseeker/feature-ads/components/AdsBanner/types';
import {Dispatch, memo, SetStateAction} from 'react';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

interface JobfeedHarnessProp {
  onLoadMore: () => void;
  routeToJobDetail: (jobSlug: string, jobId: string | number) => void;
  title: string;
  feedOnly: boolean;
  onFilterChange?: (filterData: object) => void;
  checkJobs?: number[];
  catId?: string | number;
  showPlatinumPartners?: boolean;
  platinumPartners?: AdElement;
}

const JobfeedHarness = ({
  onFilter,
  onClearFilter,
  onLoadMore,
  routeToJobDetail,
  feedOnly,
  showPlatinumPartners,
  title,
  onFilterChange,
  extractedParams,
  ...props
}: JobfeedHarnessProp | any) => {
  const interceptor: any = useInterceptor();
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const categoryId = useSelector(
    (state: AppState) => state.app.context.navigation.selected,
    shallowEqual
  );

  const {
    jobfeed: {jobInfoKeyElements},
    ads: {infeedCategory, inFeed},
  } = interceptor;

  return (
    <JobFeedsListWidget
      routeToJobDetail={routeToJobDetail}
      onLoadMore={onLoadMore}
      jobInfoKeyElements={jobInfoKeyElements}
      feedOnly={feedOnly}
      title={title}
      onFilter={onFilter}
      onClearFilter={onClearFilter}
      learnGrow={categoryId ? infeedCategory : inFeed}
      platinumPartners={props?.platinumPartners}
      onFilterChange={onFilterChange}
      showApplied={
        !isAppIimjobs && page == 'category_location_based' ? true : false
      }
      extractedParams={extractedParams}
      {...props}
    />

  );
};

export default JobfeedHarness;
